import React, {FC} from 'react';

import {Box, DialogContent, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import {When} from 'react-if';

import SameDayDeliveryIcon from 'assets/icons/sameDayDeliveryIcon';
import StoreIcon from 'assets/icons/storeIcon';
import {useAppSelector} from 'hooks';

import {BasketDialogTitle} from './BasketDialogTitle';
import {BulletPoints, Footnote, StyledBottomSheet, StyledDialog, StyledSameDelivery} from './styles';

export interface BasketDeliveryDetailsModalProps {
  open: boolean;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const BasketDeliveryDetails1PModal: FC<BasketDeliveryDetailsModalProps> = ({
  open,
  onClose,
  isReactNativeWebView
}) => {
  const currentStore = useAppSelector((state) => state?.app?.currentStore);
  const showStorePickup = !!currentStore?.showStorePickup;
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;

  return (
    <ModalContainer open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('message.delivery1PTitle')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Box display={'flex'} alignItems={'center'} gap={'8px'}>
            <StyledSameDelivery>{t('sellerDelivery.1p.sameDayDelivery')}</StyledSameDelivery>
            <SameDayDeliveryIcon />
          </Box>

          <Box paddingLeft={'5px'}>
            <BulletPoints>
              <li>
                <Typography fontSize={'14px'} fontWeight={400}>
                  <Trans i18nKey="sellerDelivery.1p.toStartDeliveryToday" />
                </Typography>
              </li>
              <li>
                <Typography fontSize={'14px'} fontWeight={400}>
                  <Trans i18nKey="sellerDelivery.1p.toStartDeliveryTomorrow" />
                </Typography>
              </li>
              <li>
                <Typography fontSize={'14px'} fontWeight={400}>
                  {t('sellerDelivery.1p.chooseDeliveryDateAndTimeOnCheckout')}
                </Typography>
              </li>
            </BulletPoints>
          </Box>

          <When condition={showStorePickup}>
            <Box display={'flex'} padding={'8px'} gap={'8px'} border={'0.5px solid #C7C7C7'} borderRadius={'8px'}>
              <StoreIcon />
              <Typography fontWeight={700} fontSize={'12px'}>
                {t('sellerDelivery.1p.storePickupAvailable')}
              </Typography>
            </Box>
          </When>
          <Footnote>*{t('sellerDelivery.1p.footnote')}</Footnote>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

BasketDeliveryDetails1PModal.displayName = 'BasketDeliveryDetails1PModal';
